import React from 'react'
import { Create, useForm } from '@refinedev/antd'
import { Form, Input, Select } from 'antd'

interface BlocklistEntry {
  term: string
  severity: 'block' | 'warn'
}

export function TextBlocklistCreate() {
  const { formProps, saveButtonProps } = useForm<BlocklistEntry>({
    resource: 'text_blocklist',
    meta: { idColumnName: 'term' },
  })

  return (
    <Create saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical" initialValues={{ severity: 'block' }}>
        <Form.Item
          label="Term"
          name="term"
          rules={[{ required: true, message: 'Term is required' }]}
          extra="Case-insensitive substring match. Keep it specific to avoid false positives."
        >
          <Input placeholder="e.g. badword" />
        </Form.Item>
        <Form.Item
          label="Severity"
          name="severity"
          rules={[{ required: true }]}
          extra='"block" hard-rejects UGC on the server. "warn" shows a client-side inline warning.'
        >
          <Select
            options={[
              { label: 'block — hard-reject on server', value: 'block' },
              { label: 'warn — soft warning on client', value: 'warn' },
            ]}
          />
        </Form.Item>
      </Form>
    </Create>
  )
}
